// extracted by mini-css-extract-plugin
export default {"subtitle":"sms-settings-page_subtitle__h-JAT","smsNote":"sms-settings-page_smsNote__KJvoU"};